"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const general_1 = require("../../assets/jss/general");
const styles = (theme) => (0, styles_1.createStyles)({
    container: general_1.container,
    coloredShadow: general_1.coloredShadow,
    centered: {
        display: 'flex',
        justifyContent: 'flex-start',
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center'
        }
    },
    centeredCarousel: {
        display: 'flex',
        justifyContent: 'flex-start',
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center'
        },
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center'
        }
    },
    cardButton: {
        marginTop: 24,
        marginBottom: 8,
        height: 50,
        minWidth: 135,
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    cardButtonCarousel: {
        marginTop: 24,
        marginBottom: 8,
        height: 50,
        minWidth: 135,
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
    footerIcon: {
        fontSize: 24,
        color: theme.palette.text.primary,
        marginRight: 4
    },
    imageConatiner: {
        overflow: 'visible',
        width: '36vw',
        height: '36vw',
        position: 'relative',
        justifyContent: 'flex-end',
        borderRadius: 5,
        marginLeft: '5px',
        [theme.breakpoints.only('xs')]: {
            width: '100%',
            height: 'auto'
        },
        [theme.breakpoints.only('sm')]: {
            width: 250,
            height: 250
        },
        [theme.breakpoints.only('md')]: {
            width: 320,
            height: 320
        },
        [theme.breakpoints.up('lg')]: {
            width: 450,
            height: 450
        },
        '& img': {
            objectFit: 'cover',
            width: '100%',
            flex: 1,
            borderRadius: 5
        }
    },
    imageConatinerCarousel: {
        overflow: 'visible',
        width: '36vw',
        height: '36vw',
        position: 'relative',
        justifyContent: 'flex-end',
        borderRadius: 5,
        [theme.breakpoints.only('xs')]: {
            width: '100%',
            height: 'auto'
        },
        [theme.breakpoints.only('sm')]: {
            width: '100%',
            height: 'auto'
        },
        [theme.breakpoints.only('md')]: {
            width: 320,
            height: 320
        },
        [theme.breakpoints.up('lg')]: {
            width: 450,
            height: 450
        },
        '& img': {
            objectFit: 'cover',
            width: '100%',
            flex: 1,
            borderRadius: 5
        }
    },
    detailsCard: {
        width: '60vw',
        [theme.breakpoints.only('xs')]: {
            width: '100%',
            marginTop: 0
        },
        [theme.breakpoints.only('sm')]: {
            width: 370
        },
        [theme.breakpoints.only('md')]: {
            width: 370
        },
        [theme.breakpoints.up('lg')]: {
            width: 480
        },
        [theme.breakpoints.up('xl')]: {
            width: 650
        }
    },
    detailsCardCarousel: {
        width: '60vw',
        [theme.breakpoints.only('xs')]: {
            width: '100%',
            marginTop: 0
        },
        [theme.breakpoints.only('sm')]: {
            width: '100%',
            marginTop: 0
        },
        [theme.breakpoints.only('md')]: {
            width: 370
        },
        [theme.breakpoints.up('lg')]: {
            width: 480
        },
        [theme.breakpoints.up('xl')]: {
            width: 660
        }
    },
    maxJackpotText: {
        position: 'absolute',
        bottom: '31px',
        right: '0%',
        width: '100%'
    }
});
exports.default = styles;
//# sourceMappingURL=FeaturedCardStyles.js.map